<template>
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :transfer-class-name="'selfMenu'"
    :visible="visible"
    class="customDrop"
    placement="bottom-start"
    ref="bussinessTypeDropRef"
    trigger="custom"
  >
    <Input
      :disabled="disabled"
      :icon="visible?'ios-arrow-up':'ios-arrow-down'"
      :placeholder="placeholder"
      :value="bussinessTypeNameMock"
      @on-focus="handleOpen"
      readonly
    ></Input>
    <DropdownMenu slot="list">
      <div
        :class="multiple? 'treeSelectPanel multipleSel': 'treeSelectPanel'"
        ref="treeSelectPanel"
      >
        <div class="flex">
          <Input
            @on-search="searchOneTree()"
            clearable
            enter-button
            placeholder="请输入关键字"
            search
            v-model.trim="filterText"
          />
        </div>
        <div class="sTreeDiv">
          <Tree
            :data="bussinessTypeList"
            :expand-node="multiple"
            :multiple="multiple"
            :show-checkbox="multiple"
            @on-check-change="checkChange"
            @on-select-change="selectChange"
            ref="sTree"
          ></Tree>
        </div>
      </div>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
import tools from "@/libs/tools"
export default {
  name: 'bussinessTypeTreeSelect',
  props: {
    disabled: {
      required: false,
      default: false
    },
    placeholder: {
      required: false,
      default: '请选择业务类型'
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      type: Number,
      default: function () {
        return null
      }
    },

    values: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    value: {
      handler (val) {
        this.selectId = val
      },
      immediate: true,
      deep: true,
    },
    values: {
      handler (val) {
        this.checkedIdList = val || []
      },
      immediate: true,
      deep: true,
    }
  },
  computed: {
    bussinessTypeNameMock: function () {
      if (this.multiple) {
        if (this.checkedIdList && this.checkedIdList.length) {
          tools.getCheckedTreeById(this.bussinessTypeList, this.checkedIdList, this.checkedList)
          this.checkedList = tools.duplicateList(this.checkedList, "id")
        } else {
          if (this.originBussinessTypeList) this.bussinessTypeList = JSON.parse(this.originBussinessTypeList)
          this.checkedList = []
        }
        return this.transNames(this.checkedList)
      } else {
        let selectList = []
        tools.getCheckedTreeById(this.bussinessTypeList, this.selectId ? [this.selectId] : [], selectList)
        return this.transNames(selectList)
      }
    }
  },
  data () {
    return {
      visible: false,
      bussinessTypeList: [],
      originBussinessTypeList: '',
      checkedList: [], //已勾选数据列表
      checkedIdList: [],
      checkedListIncludeParent: [], //已勾选数据的列表-包括父节点
      immNodesList: [], //获取选中及半选节点列表
      filterText: '',
      selectId: null,
      bussinessTypeNames: '',
    }
  },
  methods: {
    searchOneTree () {
      if (!this.filterText) {
        this.bussinessTypeList = JSON.parse(this.originBussinessTypeList)
      } else {
        this.bussinessTypeList = tools.searchTree("title", "id", this.filterText, JSON.parse(this.originBussinessTypeList))
      }
      if (this.multiple) {
        this.bussinessTypeList = tools.getCheckedTree("id", this.bussinessTypeList, this.checkedList)
      } else {
        this.bussinessTypeList = tools.getCheckedTreeById(this.bussinessTypeList, this.selectId ? [this.selectId] : [], [])
      }
    },
    selectChange (data, selectedNode) {
      let one = {}
      let selectList = []
      if (selectedNode.children && selectedNode.children.length) {
        this.$set(selectedNode, "expand", !selectedNode.expand)
        this.$set(selectedNode, "selected", false)
        this.$set(selectedNode, "checked", false)
      } else {
        this.selectId = selectedNode.id
        one = selectedNode
        selectList.push(selectedNode)
      }
      this.$emit('change', one)
    },
    checkChange (s, curr) {
      let immNodes = this.$refs.sTree.getCheckedAndIndeterminateNodes()
      immNodes.forEach((item) => { this.immNodesList.push(item) })
      this.immNodesList = tools.duplicateList(this.immNodesList, "id")
      let unCheckedIdList = tools.getUnCheckedList([curr], "checked", "id", [])
      let nodes = this.$refs.sTree.getCheckedNodes()
      nodes.forEach((item) => { this.checkedListIncludeParent.push(item) })
      this.checkedListIncludeParent = tools.duplicateList(this.checkedListIncludeParent, "id")
      let l = nodes.filter((item) => !item.children)
      l.forEach((item) => { this.checkedList.push(item) })
      this.checkedList = tools.duplicateList(this.checkedList, "id")
      if (unCheckedIdList.length) {
        this.immNodesList = this.deleteAll(this.immNodesList, unCheckedIdList)
        this.checkedList = this.deleteAll(this.checkedList, unCheckedIdList)
        this.checkedListIncludeParent = this.deleteAll(this.checkedListIncludeParent, unCheckedIdList)
      }

      this.$emit('change', this.checkedList)
    },
    transNames (arrays) {
      let nameArr = []
      if (arrays.length) {
        arrays.forEach((item) => { nameArr.push(item['title']) })
      }
      return nameArr.length ? nameArr.join('，') : ''
    },
    /**
     * 数组-删除所有满足条件的数据
     */
    deleteAll (data, e) {
      let len = data.length
      while (len--) {
        if (e.includes(data[len].id)) {
          data.splice(len, 1)
        }
      }
      return data
    },
    handleOpen: function () {
      this.visible = !this.visible
      this.filterText = ''
      this.searchOneTree()
    },
    outClick (e) {
      let bussinessTypeDropRef = this.$refs.bussinessTypeDropRef.$el
      let treeSelectPanel = this.$refs.treeSelectPanel
      if (!treeSelectPanel.contains(e.target) && !bussinessTypeDropRef.contains(e.target) && this.visible) {
        this.visible = false
      }
    },
    initBussinessTypeList: async function () {
      let that = this
      this.bussinessTypeNames = ''
      let result = await this.$baseData.handleData(false, that.$apis.ICHLApi.bussinessType.treeSelect, null) || []
      that.bussinessTypeList = result || []
      that.originBussinessTypeList = JSON.stringify(result || [])

      // this.bussinessTypeList = []
      // this.$axios.post(that.$apis.ICHLApi.bussinessType.treeSelect).then(res => {
      //   console.log('treeSelect res', res.result)
      //   if (res.success) {
      //     that.bussinessTypeList = res.result || []
      //     that.originBussinessTypeList = JSON.stringify(res.result || [])
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取业务类型失败！")
      // })
    },
  },
  beforeMount () {
    this.initBussinessTypeList()
    document.body.addEventListener('click', this.outClick)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.outClick)
  }
}
</script>
<style lang="less" scoped>
.treeSelectPanel {
  padding: 0 1rem;
  height: 370px;
  min-width: 500px;
  max-width: 610px;

  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #928d8d;
  }
  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: rgba(0, 0, 0, 0);
  }
}
.multipleSel {
  /deep/ .ivu-tree-title-selected {
    background-color: #fff;
  }
}
</style>
<style lang="less">
.selfMenu {
  max-height: 380px !important;
}
.sTreeDiv {
  height: 330px;
  overflow: auto;
}
</style>
